import React from "react"
import axios from "axios"
import OutsideClickTrigger from "../../../../booking/components/common/OutsideClickTrigger"
import PropTypes from "prop-types"
import useProfileStore from "../profileStore"

export default function ChangePasswordModal({ labels }) {
  const {
    changePasswordModalHeading,
    currentPasswordInputLabel,
    newPasswordInputLabel,
    newPasswordAgainInputLabel,
    labelButtonSave,
    labelButtonCancel,
  } = labels
  const {
    currentPassword,
    setCurrentPassword,
    newPassword,
    setNewPassword,
    repeatedNewPassword,
    setRepeatedNewPassword,

    passwordValidationMessage,
    setPasswordValidationMessage,

    setIsPasswordModalOpen,
    setAjaxSpinnerActive,
  } = useProfileStore()

  const handleSetPasswordModalOpen = (e) => {
    if (e) e.preventDefault()
    setIsPasswordModalOpen(false)
  }

  const handleChangePassword = () => {
    const digitRegex = /\d/
    const hasLowerCase = /[a-z]/
    const hasUpperCase = /[A-Z]/
    if (newPassword !== repeatedNewPassword) {
      setPasswordValidationMessage(labels.passwordRepeatUnEqual)
      return
    }

    if (!digitRegex.test(newPassword)) {
      setPasswordValidationMessage(labels.passwordDigit)
      return
    }

    if (newPassword === currentPassword) {
      setPasswordValidationMessage(labels.passwordEqualToOld)
      return
    }

    if (!hasLowerCase.test(newPassword)) {
      setPasswordValidationMessage(labels.passwordLowerCaseLetter)
      return
    }

    if (!hasUpperCase.test(newPassword)) {
      setPasswordValidationMessage(labels.passwordUpperCaseLetter)
      return
    }

    if (newPassword.length < 9) {
      setPasswordValidationMessage(labels.passwordMin)
      return
    }
    setPasswordValidationMessage(undefined)

    setAjaxSpinnerActive(true)

    const updatePassword = {
      OldPassword: currentPassword,
      NewPassword: newPassword,
    }

    axios
      .post(window.location + "/UpdatePassword", updatePassword)
      .then((res) => {
        // TODO: if response code is 200, implement communication telling user password has successfully updated.
      })
      .catch((error) => {
        // Handle errors
        console.error("Error updating password:", error.message)
      })
      .finally(() => {
        // until todo is implemented, we simply close the modal.
        setIsPasswordModalOpen(false)
        setAjaxSpinnerActive(false)
      })
  }
  return (
    <div className="overlay overlay--modal overlay--fixed is-active">
      <div className="modal">
        <OutsideClickTrigger onOutsideClick={handleSetPasswordModalOpen}>
          <div className="modal__content">
            <div className="modal__content__inner">
              <button type="button" className="button button--icon" onClick={handleSetPasswordModalOpen} style={{ backgroundColor: "#f4f4f4" }}>
                <span className="icon">
                  <svg className="svg-icon svg-icon--close">
                    <use href="/dist/svg/symbols.svg#svg-close"></use>
                  </svg>
                </span>
              </button>
              <div
                className="modal__top col--12 col-md--12 col-xs--12"
                style={{ fontWeight: "700", textAlign: "center", backgroundColor: "#f4f4f4" }}
              >
                <h3 className="headline-sm">{changePasswordModalHeading}</h3>
                <br />
              </div>
              <div
                className="modal__middle col--12 col-md--12 col-xs--12"
                style={{ overflow: "hidden", paddingBottom: "2.125rem", backgroundColor: "#f4f4f4" }}
              >
                <div className="w--narrow form">
                  <div className="grid-item col--1 col-xs--1 col-md--1"></div>

                  <div className="form__section__inner">
                    <div className={`form__field form__field--text is-bound ${currentPassword.length > 0 ? "is-filled" : ""}`}>
                      <span className="form__valid"></span>
                      <input
                        className="form__item"
                        name="OldPassword"
                        tabIndex=""
                        type="password"
                        value={currentPassword}
                        minLength="8"
                        maxLength="100"
                        onChange={(e) => setCurrentPassword(e.target.value)}
                      />
                      <label htmlFor="" className="form__label">
                        <span className="form__label__text">{currentPasswordInputLabel}</span>
                      </label>
                    </div>

                    <div
                      className={`form__field form__field--text is-bound ${passwordValidationMessage ? "is-invalid" : ""} ${
                        newPassword.length > 0 ? "is-filled" : ""
                      }`}
                    >
                      <span className="form__valid"></span>
                      <input
                        className="form__item"
                        name="NewPassword"
                        id="Password"
                        tabIndex=""
                        type="password"
                        minLength="8"
                        maxLength="100"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                      />
                      <label htmlFor="" className="form__label">
                        <span className="form__label__text">{newPasswordInputLabel}</span>
                      </label>
                    </div>

                    <div
                      className={`form__field form__field--text is-bound ${passwordValidationMessage ? "is-invalid" : ""} ${
                        repeatedNewPassword.length > 0 ? "is-filled" : ""
                      }`}
                    >
                      <span className="form__valid"></span>
                      <input
                        className="form__item"
                        name="RepeatNewPassword"
                        tabIndex=""
                        type="password"
                        minLength="8"
                        maxLength="100"
                        value={repeatedNewPassword}
                        onChange={(e) => setRepeatedNewPassword(e.target.value)}
                      />

                      <label htmlFor="" className="form__label">
                        <span className="form__label__text">{newPasswordAgainInputLabel}</span>
                      </label>
                    </div>
                  </div>
                  {passwordValidationMessage ? (
                    <span style={{ color: "#972228" }} id="Password-error" className="form__notice error-message">
                      {passwordValidationMessage}
                    </span>
                  ) : undefined}
                  <div className="form__section--no-border" style={{ clear: "both", textAlign: "center" }}>
                    <footer className="action-buttons">
                      <br />
                      <a onClick={() => handleChangePassword()} className="button button--medium button--general">
                        <span className="text">{labelButtonSave}</span>
                      </a>
                      <button type="button" className="link" onClick={(e) => handleSetPasswordModalOpen(e)}>
                        {labelButtonCancel}
                      </button>
                      <br />
                      <br />
                    </footer>
                  </div>
                  <div className="grid-item col--1 col-xs--1 col-md--1"></div>
                </div>
              </div>
            </div>
          </div>
        </OutsideClickTrigger>
      </div>
    </div>
  )
}

ChangePasswordModal.propTypes = {
  labels: PropTypes.object.isRequired,
}
